import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getAchievement } from '../../../shared/achievements';
import { getAchievementTitle } from '../../utils/i18nHelpers';

const TOAST_DURATION = 5000;

function AchievementToast() {
  const { t } = useTranslation();
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((achievementId) => {
    const def = getAchievement(achievementId);
    if (!def) return;
    const id = `${achievementId}-${Date.now()}`;
    setToasts((prev) => [...prev, { id, def }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, TOAST_DURATION);
  }, []);

  // Expose globally so mutations can trigger toasts
  useEffect(() => {
    window.__showAchievementToast = addToast;
    return () => { delete window.__showAchievementToast; };
  }, [addToast]);

  if (toasts.length === 0) return null;

  return (
    <div className="ach-toast-container">
      {toasts.map((toast) => (
        <div key={toast.id} className="ach-toast">
            <span className="ach-toast__icon">{toast.def.icon}</span>
            <div className="ach-toast__info">
              <span className="ach-toast__label">{t('achievements.toastLabel')}</span>
              <span className="ach-toast__title">{getAchievementTitle(t, toast.def.id, toast.def.title)}</span>
            </div>
          <span className="ach-toast__credits">{t('achievements.toastCredits', { count: toast.def.credits })}</span>
        </div>
      ))}
    </div>
  );
}

export default AchievementToast;
